/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'require',
	'../Toolbar',
	'jquery',
	'underscore'
], function(require, Toolbar, $, _) {

	/**
	 * Represents a drop down menu that can be added to an app bar
	 */
	var ToggleButtonBar = Toolbar.extend({
		baseClass: 'appbar',
		sCheckedItemName: null,
		requireFn: require,

		/**
		 * Creates a new item
		 *
		 * @param spec -
		 *            The item spec
		 * @param root -
		 *            A reference to the root menu item, where items go if the app bar is collapsed horizontally
		 */
		init: function(spec) {
			_.extend(this, spec);
			ToggleButtonBar.inherited('init', this, arguments);
		},

		_renderItem: function(itemSpec, $item){
			itemSpec.type = 'ToggleButton';

			//Add container callback
			itemSpec.containerCallbacks = {
				'click': function() {
					this.toggleHandler(itemSpec.name);
				}.bind(this)
			};

			return this._loadModule('./' + itemSpec.type)
				.then((Item) => {
					itemSpec.el = $item;

					var item = new Item(itemSpec, this.rootMenu);
					item.render();
					this.itemMap[itemSpec.name] = item;
				});
		},

		_loadModule: function(module) {
			return new Promise((resolve, reject) => {
				try {
					this.requireFn([module], resolve, reject);
				} catch(error) {
					reject(error);
				}
			});
		},

		toggleHandler: function(name) {
			//uncheck current item
			if (this.sCheckedItemName) {
				var oItem = this.itemMap[this.sCheckedItemName];
				oItem.unselect();
			}
			//updated check item name
			this.sCheckedItemName = name;
		},

		/**
		 * Changes selected item without invoking the action. i.e, Selects without action
		 */
		updateSelectedItem: function(name) {
			this.toggleHandler(name);

			var oItem = this.itemMap[this.sCheckedItemName];
			if (oItem) {
				oItem.updateUI(true);
			}
		},

		/**
		 * Draws the items
		 */
		render: function() {
			let promise;

			this.$el.empty();
			this.$el.addClass(this.baseClass + 'ItemWrapper');

			if (this.items) {
				let promises = _.map(this.items, (item) => {
					if (item.checked) {
						if (!this.sCheckedItemName) {
							this.sCheckedItemName = item.name;
						} else {
							//Only one item should have checked specified. Ignore
							item.checked = false;
						}
					}
					return this.addItem(item);
				});

				promise = Promise.all(promises);

				if (!this.sCheckedItemName) { //Check first item if not specified
					var jFirstItem = this.items[0];
					this.toggleHandler(jFirstItem.name);
				}
			}
			return promise || Promise.resolve();
		}
	});

	return ToggleButtonBar;
});
